// Bilingual dictionary for Mera Naksha
export const LANGS = [
  { code: "hi", label: "हिंदी", short: "अ" },
  { code: "en", label: "English", short: "A" },
];

export const translations = {
  hi: {
    brand: "मेरा नक्शा",
    brand_tagline: "अपने सपनों का घर",
    nav_login: "साइन इन",

    // Hero (Aspirational)
    hero_eyebrow: "भारत का तकनीक-आधारित प्लानिंग प्लेटफ़ॉर्म",
    hero_title_aspire_1: "अब गाँव में भी बनेगा",
    hero_title_aspire_2: "शहर जैसा शानदार घर",
    hero_sub:
      "तजुर्बेकार Design Mitra से 2D व 3D Concept Plan पाएं — आसान, भरोसेमंद, आपकी अपनी भाषा में।",

    chat_namaste: "नमस्ते जी 🙏 मेरा नक्शा में आपका स्वागत है।",
    chat_ask: "अपना प्लॉट साइज़ बताइए और कितने कमरे चाहिए?",

    badge_arch: "500+ Design Mitras",
    badge_proj: "10,000+ Concept Plans",
    badge_safe: "100% सुरक्षित पेमेंट",
    badge_lang: "5 भाषाएँ",

    // Aspirational / Before-After
    showcase_eyebrow: "पुराना vs नया",
    showcase_title: "आपका घर भी बन सकता है",
    showcase_title_hl: "ऐसा शानदार",
    showcase_sub:
      "गाँव और छोटे शहरों में रहते हुए भी, मॉडर्न डिज़ाइन और सही नक्शे से आपका घर शहर से कम नहीं।",
    before_label: "पहले",
    before_caption: "बिना नक्शा का पुराना घर",
    after_label: "बाद में",
    after_caption: "मेरा नक्शा से शानदार घर",
    showcase_chip_1: "मॉडर्न elevation",
    showcase_chip_2: "बेहतर वेंटिलेशन",
    showcase_chip_3: "Vastu-Optimized",

    // Savings
    savings_eyebrow: "बचत कैलकुलेटर",
    savings_title: "सही Concept Plan मतलब",
    savings_title_hl: "₹50,000 तक की बचत",
    savings_sub:
      "बिना standardized concept plan के सरिया, सीमेंट और मज़दूरी पर बहुत पैसा बर्बाद होता है। देखिए आप कितना बचाएँगे:",
    savings_choose_plot: "अपना प्लॉट साइज़ चुनिए",
    savings_without: "बिना Plan",
    savings_with: "मेरा नक्शा से",
    savings_wasted: "बर्बादी",
    savings_saved: "बचत",
    savings_iron: "सरिया",
    savings_cement: "सीमेंट",
    savings_labour: "मज़दूरी",
    savings_total: "कुल बचत",
    savings_disclaimer: "* अनुमानित बचत। असली बचत साइट और डिज़ाइन पर निर्भर करती है।",
    share_btn: "अपनी बचत शेयर करें",
    share_download: "कार्ड डाउनलोड करें",
    share_wa: "WhatsApp पर भेजें",
    share_msg: "मैं Mera Naksha से अपने नए घर पर ₹{X} तक की बचत कर रहा/रही हूँ! आप भी देखिए:",
    share_card_kicker: "मेरा नक्शा • बचत कार्ड",
    share_card_total: "मेरी कुल बचत",
    share_card_for: "{X} वर्ग फुट के प्लॉट पर",
    share_card_cta: "अपने सपनों का घर WhatsApp पर बनवाएं",

    // Capture
    section_capture: "अपनी ज़रूरत बताइए",
    section_capture_sub: "बस 2 आसान सवाल — कोई भी टाइप नहीं करना",
    step_label: "स्टेप 1 / 3",
    zameen_title: "ज़मीन का साइज़",
    zameen_sub: "आपका प्लॉट कितना बड़ा है?",
    kamre_title: "कितने कमरे चाहिए?",
    kamre_sub: "बेडरूम की संख्या चुनिए",
    sqft: "वर्ग फुट",
    rooms: "कमरे",
    bhk: "BHK",

    cta_continue: "आगे बढ़ें — WhatsApp पर शुरू करें",
    cta_whatsapp: "WhatsApp पर शुरू करें",
    cta_disabled: "पहले विकल्प चुनिए",

    // Trust
    trust_title: "कैसे काम करता है?",
    trust_step1_t: "ज़रूरत बताइए",
    trust_step1_d: "WhatsApp पर वॉइस या फोटो भेजिए",
    trust_step2_t: "डिज़ाइन मित्र से बात करें",
    trust_step2_d: "हम आपके लिए सही डिज़ाइन मित्र चुनेंगे",
    trust_step3_t: "Concept Plan पाइए",
    trust_step3_d: "2D, 3D व Planning Package — आपके फ़ोन पर",
    footer_safe: "सुरक्षित पेमेंट • मनी-बैक गारंटी",

    community_nav: "कम्युनिटी जॉइन करें",
    community_eyebrow: "घर बनाओ कम्युनिटी",
    community_title: "WhatsApp ग्रुप जॉइन करें",
    community_msg:
      "घर बनाओ WhatsApp ग्रुप जॉइन करें: एक्सपर्ट सलाह और नए डिज़ाइन के लिए।",
    community_members: "12,000+ सदस्य",
    community_perk_1: "रोज़ नए Concept Plans",
    community_perk_2: "एक्सपर्ट Q&A",
    community_perk_3: "बजट टिप्स",
    community_cta: "अभी ग्रुप जॉइन करें",
    community_disclaimer: "मुफ़्त • कोई स्पैम नहीं • कभी भी छोड़ सकते हैं",

    plot_xs: "छोटा प्लॉट",
    plot_s: "मध्यम प्लॉट",
    plot_m: "बड़ा प्लॉट",
    plot_l: "बहुत बड़ा",
    selected: "चुना गया",

    // Plot facing (Vastu / direction)
    facing_title: "प्लॉट किस दिशा में है?",
    facing_sub: "मुख्य द्वार किस तरफ खुलेगा",
    facing_north: "उत्तर",
    facing_south: "दक्षिण",
    facing_east: "पूर्व",
    facing_west: "पश्चिम",
    plot_dim_title: "प्लॉट का साइज़ (लम्बाई × चौड़ाई)",
    plot_dim_sub: "अपना प्लॉट चुनिए",

    // Mera Naksha Design Library (formerly "Concept Plan Store" / "Naksha Bazaar")
    store_kicker: "Design Library",
    store_title: "रेडीमेड Concept Plans",
    store_eyebrow: "इंस्टेंट डाउनलोड",
    store_h1_a: "Standardized Concept Plans",
    store_h1_b: "अभी डाउनलोड करें",
    store_sub:
      "Vastu-Optimized, professional 2D + 3D Concept Plans एक क्लिक में। पेमेंट करें और तुरंत PDF/JPG डाउनलोड पाएँ।",
    store_perk_1: "Vastu-Optimized",
    store_perk_2: "इंस्टेंट डाउनलोड",
    store_perk_3: "हाई-रेज़ फाइल",
    store_search_ph: "साइज़ या नाम खोजें (e.g. 20x40)",
    store_all_sizes: "सभी साइज़",
    store_loading: "Concept Plans लोड हो रहे हैं…",
    store_empty: "इस साइज़ में अभी कोई डिज़ाइन नहीं — जल्द जोड़े जाएँगे।",
    store_price: "कीमत",
    store_buy_cta: "Concept Plan खरीदें",
    store_trust_t: "100% सुरक्षित डाउनलोड",
    store_trust_d: "पेमेंट के बाद 2D Concept Plan फ़ाइल तुरंत डाउनलोड हो जाएगी।",
    store_landing_kicker: "नया",
    store_landing_title: "Mera Naksha Design Library — रेडीमेड डिज़ाइन",
    store_landing_sub:
      "अब रुकना नहीं — हमारी Design Library से अपने प्लॉट के लिए तैयार Concept Plan अभी ख़रीदें और डाउनलोड करें।",
    store_landing_cta: "Design Library देखें",
    store_landing_count: "तैयार Concept Plans",

    // Card labels (legal-safe descriptors)
    card_plot_size: "Plot Size",
    card_builtup: "Built-up Area",
    card_bedrooms: "Bedrooms",
    card_concept_plan: "Concept Plan",

    // Legal-safe disclaimer (rendered near every Buy/Download CTA + in footer)
    legal_disclaimer_short:
      "केवल planning / reference के लिए — Elevations, MEP, Structural Drawings अलग से उपलब्ध हैं। final design और local approvals licensed professionals से verify कराना अनिवार्य है।",
    legal_disclaimer_full:
      "This is a planning concept layout intended for reference and pre-construction discussion only. 2D Elevations, MEP, and Structural Drawings are NOT included and are available on request. Final structural design, local authority approvals, and execution drawings must be verified by licensed professionals as per applicable local regulations.",

    // Phase-1 product scope
    pkg_name: "Full Concept Layout Package",
    pkg_starting_at: "से शुरू",
    phase1_inc_title: "इस पैकेज में क्या मिलता है",
    phase1_inc_1: "2D Concept Layout (PDF) — पूरा प्लान",
    phase1_inc_2: "वास्तु-Optimized कमरे की व्यवस्था",
    phase1_inc_3: "Plot Size · Built-up Area · Bedroom layout",
    phase1_inc_4: "Vehicle parking व open space सुझाव",
    phase1_exc_title: "इस पैकेज में शामिल नहीं है",
    phase1_exc_1: "2D Elevations (front view drawings)",
    phase1_exc_2: "MEP Drawings (Electrical, Plumbing, HVAC)",
    phase1_exc_3: "Structural Drawings (RCC, foundation)",
    phase1_exc_4: "Site supervision / execution",

    // Add-ons
    addons_title: "Customization & Add-ons",
    addons_message:
      "Elevation, MEP, या Structural Drawings चाहिए? Team Mera Naksha से custom quote के लिए संपर्क करें — आपकी ज़रूरत के हिसाब से।",
    addons_cta_wa: "WhatsApp पर Add-ons मंगवाएँ",
    addons_cta_email: "Email से custom quote मँगवाएँ",
    addons_disclaimer:
      "Add-ons अलग scope के हैं और इनकी कीमत आपकी site, ज़रूरत और local regulations के अनुसार तय होती है।",

    // Vision · Mission · Mission Snippet (brand-led, nation-building tone)
    brand_official_tagline: "Building Space Today, Building Wealth Tomorrow",
    about_kicker: "हमारे बारे में",
    about_headline:
      "Bharat के घर बनाने का तरीका — अब नए सिरे से।",
    about_intro:
      "Mera Naksha एक technology-driven design ecosystem है। हम homeowners और building professionals को एक ही platform पर लाते हैं — standardized Concept Plans, verified Design Mitras और trusted workflows के साथ। Bharat के residential construction की digital infrastructure हम बना रहे हैं।",
    vision_label: "हमारा Vision",
    vision_text:
      "Bharat के residential building revolution का architect बनना — जहाँ हर परिवार, metros से लेकर सबसे दूर के गाँव तक, professional building design उतनी ही आसानी से access कर सके जितनी आसानी से smartphone।",
    mission_label: "हमारा Mission",
    mission_text:
      "Mera Naksha Bharat के residential construction की digital infrastructure बना रहा है। हम homeowners और building professionals को technology-driven design ecosystem के ज़रिए empower करते हैं — standardized Planning Systems, verified Design Mitras और trusted workflows से, ताकि लाखों unsafe self-built घर सुरक्षित और गरिमामय बनें।",
    mission_snippet:
      "Building the digital infrastructure for Bharat's residential construction. Empowering homeowners and professionals through technology-driven design.",

    // Checkout modal
    store_checkout_kicker: "चेकआउट",
    store_receipt_kicker: "रसीद",
    store_field_name: "आपका नाम",
    store_field_name_ph: "जैसे: रमेश कुमार",
    store_field_wa: "WhatsApp नंबर",
    store_secure_note: "100% सुरक्षित पेमेंट • मनी-बैक गारंटी",
    store_pay_now: "पेमेंट करें",
    store_paying: "पेमेंट हो रहा है…",
    store_err_name: "कृपया अपना नाम भरें",
    store_err_phone: "10 अंकों का सही नंबर भरें",
    store_err_generic: "पेमेंट विफल — फिर से कोशिश करें",
    store_success_title: "पेमेंट सफल हुआ!",
    store_success_sub: "Concept Plan डाउनलोड शुरू हो गया है।",
    store_receipt_no: "रसीद",
    store_paid: "भुगतान",
    store_download_plan: "2D Concept Plan डाउनलोड करें",
    store_send_wa: "WhatsApp पर भेजें",

    // Admin library manager
    admin_lib_title: "लाइब्रेरी मैनेजर",
    admin_lib_sub: "नया डिज़ाइन जोड़ें और मौजूदा देखें",
    admin_lib_add: "नया डिज़ाइन जोड़ें",
    admin_lib_name: "डिज़ाइन का नाम",
    admin_lib_size: "साइज़ (e.g. 20x40)",
    admin_lib_area: "एरिया (sq ft)",
    admin_lib_price: "कीमत (₹)",
    admin_lib_facing: "दिशा",
    admin_lib_image: "3D रेंडर इमेज URL",
    admin_lib_plan: "2D प्लान फ़ाइल URL",
    admin_lib_badge: "बैज (वैकल्पिक)",
    admin_lib_save: "डिज़ाइन सेव करें",
    admin_lib_delete: "हटाएँ",

    // Mera Naksha Design Library — /store page hero block
    bz_kicker: "Mera Naksha Design Library",
    bz_title: "तैयार Concept Plans",
    bz_eyebrow: "100+ Concept Plans • इंस्टेंट डाउनलोड",
    bz_h1_a: "अपना घर खोजें —",
    bz_h1_b: "बस फ़िल्टर लगाएं",
    bz_sub: "100+ standardized house Concept Plans — Plot Size, दिशा और Bedrooms से तुरंत खोजें।",
    bz_perk_1: "Vastu-Optimized",
    bz_perk_2: "इंस्टेंट डाउनलोड",
    bz_perk_3: "हाई-रेज़ फाइल",
    bz_search_ph: "नाम या साइज़ खोजें (e.g. 20x40)",
    bz_filters: "फ़िल्टर",
    bz_filter_area: "Plot Size",
    bz_filter_facing: "दिशा",
    bz_filter_bhk: "Bedrooms",
    bz_facing_any: "कोई भी",
    bz_bhk_any: "कोई भी",
    bz_area_any: "सभी Plot Sizes",
    bz_area_xs: "500 sqft से कम",
    bz_area_s: "500–1000 sqft",
    bz_area_m: "1000–1500 sqft",
    bz_area_l: "1500–2500 sqft",
    bz_area_xl: "2500+ sqft",
    bz_clear_all: "फ़िल्टर हटाएँ",
    bz_show_results: "परिणाम दिखाएँ",
    bz_designs_found: "Concept Plans मिले",
    bz_loading: "लोड हो रहा है…",
    bz_loading_more: "और लोड हो रहे हैं…",
    bz_end: "बस इतना ही",
    bz_empty_t: "कोई Concept Plan नहीं मिला",
    bz_empty_d: "फ़िल्टर बदलकर देखें।",
    bz_card_zoom: "बड़ा देखें",
    bz_preview_2d: "2D Concept Plan देखें",
    bz_view_3d: "3D रेंडर देखें",
    bz_2d_locked: "पूरा Concept Plan खरीदने पर अनलॉक होगा",
    bz_2d_pdf_t: "PDF Concept Plan",
    bz_2d_pdf_d: "खरीदने के बाद पूरा PDF डाउनलोड करें।",
    bz_unlock_full: "अनलॉक और डाउनलोड",
    bz_trust_t: "100% सुरक्षित डाउनलोड",
    bz_trust_d: "पेमेंट के बाद 2D Concept Plan फ़ाइल तुरंत डाउनलोड हो जाएगी।",
    bz_bestseller: "बेस्टसेलर",

    // Admin Design Database
    db_title: "डिज़ाइन डेटाबेस",
    db_sub: "100+ डिज़ाइन — खोजें, जोड़ें, बदलें, हटाएँ",
    db_bulk_add: "Bulk Add",
    db_search_ph: "नाम / साइज़ / बैज खोजें",
    db_total: "कुल",
    db_col_design: "डिज़ाइन",
    db_col_size: "साइज़",
    db_col_bhk: "BHK",
    db_col_facing: "दिशा",
    db_col_price: "कीमत",
    db_col_actions: "एक्शन",
    db_edit: "बदलें",
    db_delete: "हटाएँ",
    db_save: "सेव करें",
    db_cancel: "रद्द करें",
    db_add_title: "नया डिज़ाइन जोड़ें",
    db_edit_title: "डिज़ाइन बदलें",
    db_field_name: "डिज़ाइन का नाम",
    db_field_width: "प्लॉट चौड़ाई (ft)",
    db_field_depth: "प्लॉट लम्बाई (ft)",
    db_field_facing: "दिशा (N/S/E/W)",
    db_field_bhk: "BHK",
    db_field_price: "कीमत (₹)",
    db_field_image: "3D व्यू URL",
    db_field_plan: "2D प्लान URL",
    db_field_badge: "बैज (वैकल्पिक)",
    db_no_results: "कोई डिज़ाइन नहीं मिला।",
    db_loading: "लोड हो रहा है…",
    db_prev: "पिछला",
    db_next: "अगला",
    db_page: "पेज",
    db_of: "में से",
  },
  en: {
    brand: "Mera Naksha",
    brand_tagline: "Build your dream home",
    nav_login: "Sign in",

    hero_eyebrow: "Bharat's technology-enabled planning platform",
    hero_title_aspire_1: "Now villages will also have",
    hero_title_aspire_2: "magnificent city-like homes",
    hero_sub:
      "Get 2D & 3D Concept Plans from verified Design Mitras — simple, trusted, in your language.",

    chat_namaste: "Namaste 🙏 Welcome to Mera Naksha.",
    chat_ask: "Tell us your plot size and how many rooms you need.",

    badge_arch: "500+ Design Mitras",
    badge_proj: "10,000+ Concept Plans delivered",
    badge_safe: "100% safe payments",
    badge_lang: "5 languages",

    showcase_eyebrow: "Before vs After",
    showcase_title: "Your home can also be",
    showcase_title_hl: "this magnificent",
    showcase_sub:
      "Even in a village or small town, with modern design and the right plan your home looks no less than the city.",
    before_label: "Before",
    before_caption: "Old house, no plan",
    after_label: "After",
    after_caption: "Mera Naksha home",
    showcase_chip_1: "Modern elevation",
    showcase_chip_2: "Better ventilation",
    showcase_chip_3: "Vastu-Optimized",

    savings_eyebrow: "Savings calculator",
    savings_title: "The right Concept Plan means",
    savings_title_hl: "savings up to ₹50,000",
    savings_sub:
      "Without a standardized concept plan, a lot of iron, cement and labour go waste. See how much you can save:",
    savings_choose_plot: "Choose your plot size",
    savings_without: "Without plan",
    savings_with: "With Mera Naksha",
    savings_wasted: "Wasted",
    savings_saved: "Saved",
    savings_iron: "Iron (sariya)",
    savings_cement: "Cement",
    savings_labour: "Labour",
    savings_total: "Total savings",
    savings_disclaimer: "* Estimated savings. Actual depends on site & design.",

    section_capture: "Tell us what you need",
    section_capture_sub: "Just 2 quick questions — no typing required",
    step_label: "Step 1 of 3",
    zameen_title: "Plot size",
    zameen_sub: "How big is your plot?",
    kamre_title: "How many rooms?",
    kamre_sub: "Choose number of bedrooms",
    sqft: "sq ft",
    rooms: "rooms",
    bhk: "BHK",

    cta_continue: "Continue on WhatsApp",
    cta_whatsapp: "Start on WhatsApp",
    cta_disabled: "Pick an option first",

    trust_title: "How it works",
    trust_step1_t: "Share your need",
    trust_step1_d: "Send a voice note or photo on WhatsApp",
    trust_step2_t: "Talk to a Design Mitra",
    trust_step2_d: "We match you with the right Design Mitra",
    trust_step3_t: "Get your Concept Plan",
    trust_step3_d: "2D, 3D & Planning Package — delivered to your phone",
    footer_safe: "Safe payments • Money-back guarantee",

    community_nav: "Join Community",
    community_eyebrow: "Ghar Banao Community",
    community_title: "Join our WhatsApp group",
    community_msg:
      "Ghar Banao WhatsApp Group Join Karein: Expert advice aur naye designs ke liye.",
    community_members: "12,000+ members",
    community_perk_1: "Daily new Concept Plans",
    community_perk_2: "Expert Q&A",
    community_perk_3: "Budget tips",
    community_cta: "Join the group now",
    community_disclaimer: "Free • No spam • Leave anytime",

    plot_xs: "Small plot",
    plot_s: "Medium plot",
    plot_m: "Large plot",
    plot_l: "Very large",
    selected: "Selected",

    // Plot facing
    facing_title: "Which way does the plot face?",
    facing_sub: "Direction the main door opens to",
    facing_north: "North",
    facing_south: "South",
    facing_east: "East",
    facing_west: "West",
    plot_dim_title: "Plot size (Length × Width)",
    plot_dim_sub: "Pick your plot dimensions",

    // Mera Naksha Design Library (formerly "Concept Plan Store" / "Naksha Bazaar")
    store_kicker: "Design Library",
    store_title: "Ready Concept Plans",
    store_eyebrow: "Instant download",
    store_h1_a: "Standardized Concept Plans",
    store_h1_b: "download right now",
    store_sub:
      "Vastu-Optimized, professional 2D + 3D Concept Plans in one click. Pay and instantly download a high-res PDF/JPG.",
    store_perk_1: "Vastu-Optimized",
    store_perk_2: "Instant download",
    store_perk_3: "High-res file",
    store_search_ph: "Search size or name (e.g. 20x40)",
    store_all_sizes: "All sizes",
    store_loading: "Loading Concept Plans…",
    store_empty: "No Concept Plans in this size yet — coming soon.",
    store_price: "Price",
    store_buy_cta: "Get Concept Plan",
    store_trust_t: "100% safe download",
    store_trust_d: "After payment your 2D Concept Plan downloads instantly.",
    store_landing_kicker: "New",
    store_landing_title: "Mera Naksha Design Library — ready-made designs",
    store_landing_sub:
      "Don't wait. Browse our Design Library, buy a ready 2D + 3D Concept Plan that fits your plot, and download it instantly.",
    store_landing_cta: "Browse Design Library",
    store_landing_count: "ready Concept Plans",

    // Card labels (legal-safe descriptors)
    card_plot_size: "Plot Size",
    card_builtup: "Built-up Area",
    card_bedrooms: "Bedrooms",
    card_concept_plan: "Concept Plan",

    // Legal-safe disclaimer (rendered near every Buy/Download CTA + in footer)
    legal_disclaimer_short:
      "For planning / reference only — Elevations, MEP & Structural Drawings are available on request. Final design and local approvals must be verified by licensed professionals.",
    legal_disclaimer_full:
      "This is a planning concept layout intended for reference and pre-construction discussion only. 2D Elevations, MEP, and Structural Drawings are NOT included and are available on request. Final structural design, local authority approvals, and execution drawings must be verified by licensed professionals as per applicable local regulations.",

    // Phase-1 product scope
    pkg_name: "Full Concept Layout Package",
    pkg_starting_at: "starting at",
    phase1_inc_title: "What you get in this package",
    phase1_inc_1: "2D Concept Layout (PDF) — complete plan",
    phase1_inc_2: "Vastu-Optimized room arrangement",
    phase1_inc_3: "Plot Size · Built-up Area · Bedroom layout",
    phase1_inc_4: "Vehicle parking & open-space suggestions",
    phase1_exc_title: "Not included in this package",
    phase1_exc_1: "2D Elevations (front view drawings)",
    phase1_exc_2: "MEP Drawings (Electrical, Plumbing, HVAC)",
    phase1_exc_3: "Structural Drawings (RCC, foundation)",
    phase1_exc_4: "Site supervision / execution",

    // Add-ons
    addons_title: "Customization & Add-ons",
    addons_message:
      "Need Elevation, MEP, or Structural Drawings? Contact Team Mera Naksha for custom quotes based on your specific requirements.",
    addons_cta_wa: "Request Add-ons on WhatsApp",
    addons_cta_email: "Email for a custom quote",
    addons_disclaimer:
      "Add-ons have a separate scope and are priced based on your site, requirements, and local regulations.",

    // Vision · Mission · Mission Snippet (brand-led, nation-building tone)
    brand_official_tagline: "Building Space Today, Building Wealth Tomorrow",
    about_kicker: "About Mera Naksha",
    about_headline:
      "Reimagining how Bharat builds its homes.",
    about_intro:
      "Mera Naksha is a technology-driven design ecosystem. We bring homeowners and building professionals onto a single platform — standardized Concept Plans, verified Design Mitras, and trusted workflows that make professional building design accessible to every Indian family.",
    vision_label: "Our Vision",
    vision_text:
      "To architect Bharat's residential building revolution — where every family, from metros to the remotest village, can access professional building design as easily as they access a smartphone.",
    mission_label: "Our Mission",
    mission_text:
      "Mera Naksha is building the digital infrastructure for Bharat's residential construction. We empower homeowners and building professionals through a technology-driven design ecosystem — standardized Planning Systems, verified Design Mitras, and trusted workflows that turn lakhs of unsafe self-built homes into safer, dignified ones.",
    mission_snippet:
      "Building the digital infrastructure for Bharat's residential construction. Empowering homeowners and professionals through technology-driven design.",

    // Checkout modal
    store_checkout_kicker: "Checkout",
    store_receipt_kicker: "Receipt",
    store_field_name: "Your name",
    store_field_name_ph: "e.g. Ramesh Kumar",
    store_field_wa: "WhatsApp number",
    store_secure_note: "100% safe payment • Money-back guarantee",
    store_pay_now: "Pay now",
    store_paying: "Processing…",
    store_err_name: "Please enter your name",
    store_err_phone: "Enter a valid phone number",
    store_err_generic: "Payment failed — please retry",
    store_success_title: "Payment successful!",
    store_success_sub: "Your Concept Plan download has started.",
    store_receipt_no: "Receipt",
    store_paid: "Paid",
    store_download_plan: "Download 2D Concept Plan",
    store_send_wa: "Send to WhatsApp",

    // Admin library manager
    admin_lib_title: "Library Manager",
    admin_lib_sub: "Add new designs and review the catalogue",
    admin_lib_add: "Add new design",
    admin_lib_name: "Design name",
    admin_lib_size: "Size (e.g. 20x40)",
    admin_lib_area: "Area (sq ft)",
    admin_lib_price: "Price (₹)",
    admin_lib_facing: "Facing",
    admin_lib_image: "3D render image URL",
    admin_lib_plan: "2D plan file URL",
    admin_lib_badge: "Badge (optional)",
    admin_lib_save: "Save design",
    admin_lib_delete: "Delete",

    // Mera Naksha Design Library — /store page hero block
    bz_kicker: "Mera Naksha Design Library",
    bz_title: "Ready Concept Plans",
    bz_eyebrow: "100+ Concept Plans • Instant download",
    bz_h1_a: "Find your home —",
    bz_h1_b: "filter & download",
    bz_sub: "100+ standardized house Concept Plans — search by Plot Size, facing and Bedrooms in seconds.",
    bz_perk_1: "Vastu-Optimized",
    bz_perk_2: "Instant download",
    bz_perk_3: "High-res file",
    bz_search_ph: "Search name or size (e.g. 20x40)",
    bz_filters: "Filters",
    bz_filter_area: "Plot Size",
    bz_filter_facing: "Facing",
    bz_filter_bhk: "Bedrooms",
    bz_facing_any: "Any",
    bz_bhk_any: "Any",
    bz_area_any: "All Plot Sizes",
    bz_area_xs: "Below 500 sqft",
    bz_area_s: "500–1000 sqft",
    bz_area_m: "1000–1500 sqft",
    bz_area_l: "1500–2500 sqft",
    bz_area_xl: "2500+ sqft",
    bz_clear_all: "Clear filters",
    bz_show_results: "Show results",
    bz_designs_found: "Concept Plans found",
    bz_loading: "Loading…",
    bz_loading_more: "Loading more…",
    bz_end: "End of catalogue",
    bz_empty_t: "No Concept Plans match",
    bz_empty_d: "Try changing your filters.",
    bz_card_zoom: "Tap to zoom",
    bz_preview_2d: "Preview 2D Concept Plan",
    bz_view_3d: "View 3D render",
    bz_2d_locked: "Full Concept Plan unlocks after purchase",
    bz_2d_pdf_t: "PDF Concept Plan",
    bz_2d_pdf_d: "Download the full PDF after purchase.",
    bz_unlock_full: "Unlock & Download",
    bz_trust_t: "100% safe download",
    bz_trust_d: "After payment your 2D Concept Plan downloads instantly.",
    bz_bestseller: "Bestseller",

    // Admin Design Database
    db_title: "Design Database",
    db_sub: "100+ designs — search, add, edit, delete",
    db_bulk_add: "Bulk Add",
    db_search_ph: "Search name / size / badge",
    db_total: "Total",
    db_col_design: "Design",
    db_col_size: "Size",
    db_col_bhk: "BHK",
    db_col_facing: "Facing",
    db_col_price: "Price",
    db_col_actions: "Actions",
    db_edit: "Edit",
    db_delete: "Delete",
    db_save: "Save",
    db_cancel: "Cancel",
    db_add_title: "Add new design",
    db_edit_title: "Edit design",
    db_field_name: "Design name",
    db_field_width: "Plot width (ft)",
    db_field_depth: "Plot depth (ft)",
    db_field_facing: "Facing (N/S/E/W)",
    db_field_bhk: "BHK",
    db_field_price: "Price (₹)",
    db_field_image: "3D view URL",
    db_field_plan: "2D plan URL",
    db_field_badge: "Badge (optional)",
    db_no_results: "No designs match.",
    db_loading: "Loading…",
    db_prev: "Prev",
    db_next: "Next",
    db_page: "Page",
    db_of: "of",
  },
};

export const t = (lang, key) =>
  (translations[lang] && translations[lang][key]) || translations.en[key] || key;
